import Vue from 'vue'
import App from './App.vue'
import vuetify from './plugins/vuetify'
import router from './router'
import axiosPlugin from './plugins/axios';
import store from './store'

Vue.config.productionTip = false

Vue.use(axiosPlugin);

new Vue({
  vuetify,
  router,
  store,
  render: h => h(App)
}).$mount('#app')
